@if (field.type !== 'booleanInput') {
  <spot-form-field
    [control]="field?.formControl"
    [label]="to?.label"
    [hidden]="field?.hide"
    [noWrapLabel]="to?.noWrapLabel"
    [required]="to?.required"
    [helpTextAttribute]="to?.property"
    [helpTextAttributeScope]="to?.helpTextAttributeScope || dynamicFormComponent?.helpTextAttributeScope"
    [showValidationErrorOn]="to?.showValidationErrorOn || dynamicFormComponent?.showValidationErrorsOn"
    [attr.data-qa-field-name]="to?.property"
    >
    <ng-container #fieldComponent slot="input" />
    <attribute-help-text slot="help-text"
      class="spot-form-field--help-text"
      [attribute]="to?.property"
      [attributeScope]="to?.helpTextAttributeScope || dynamicFormComponent?.helpTextAttributeScope"
     />
    <formly-validation-message class="spot-form-field--error"
      [field]="field"
      slot="errors"
     />
  </spot-form-field>
}

@if (field.type === 'booleanInput') {
  <spot-selector-field
    [control]="field?.formControl"
    [label]="to?.label"
    [hidden]="field?.hide"
    [required]="to?.required"
    [showValidationErrorOn]="to?.showValidationErrorOn || dynamicFormComponent?.showValidationErrorsOn"
    [attr.data-qa-field-name]="to?.property"
    >
    <ng-container #fieldComponent slot="input" />
    <attribute-help-text slot="help-text"
      class="spot-form-field--help-text"
      [attribute]="to?.property"
      [attributeScope]="to?.helpTextAttributeScope || dynamicFormComponent?.helpTextAttributeScope"
     />
    <formly-validation-message class="spot-form-field--error"
      [field]="field"
      slot="errors"
     />
  </spot-selector-field>
}
